<template>
    <div class="w-full">
        <vs-tabs alignment="fixed">
            <vs-tab v-for="lang in langs" :key="lang" :label="lang" class="px-0">
                <div class="w-full">
                    <div class="my-3">
                        <vs-checkbox v-model="inputs[lang].visibility">{{$t('Visivel')}}</vs-checkbox>
                    </div>

                    <div class="mb-3">
                        <vs-input class="w-full" v-model="inputs[lang].name" size="medium" :label="$t('nome')"/>
                    </div>

                    <div class="mb-3">
                        <vs-textarea class="w-full" v-model="inputs[lang].description" size="medium" :label="$t('Descrição')"></vs-textarea>
                    </div>
                </div>
            </vs-tab>
        </vs-tabs>

        <vs-divider />

        <div class="w-full mt-3">
            <vs-checkbox v-model="visibility">{{$t('Visivel')}}</vs-checkbox>
        </div>  

        <div class="mt-5">
            <vs-button class="sm:w-full lg:w-1/5" color="success" type="filled" v-on:click="submitMenu()">{{$t('Gravar')}}</vs-button>
        </div>
    </div>
</template>

<script>
import draggable from 'vuedraggable'

export default {
    props: [
        'hotel_id',
        'type_selected',
        'menu'
    ],
    data() {
        return {            
            inputs: {
                'PT': {
                    name: '',
                    description: '',
                    information: '',
                    visibility: 1,
                },
                'BR': {
                    name: '',
                    description: '',
                    information: '',
                    visibility: 1,
                },
                'EN': {
                    name: '',
                    description: '',
                    information: '',
                    visibility: 1,
                },
                'FR': {
                    name: '',
                    description: '',
                    information: '',
                    visibility: 1,
                },
                'DE': {
                    name: '',
                    description: '',
                    information: '',
                    visibility: 1,
                },
                'ES': {
                    name: '',
                    description: '',
                    information: '',
                    visibility: 1,
                }
            },
            chapter: '',
            coin_selected: '',
            information: '',
            description: '',
            price: '',
            moedas: ['Euro', 'Real', 'Dollar'],
            files: {
                thumbnail_files: []
            },
            chapter: '',
            coin_selected: '',
            information: '',
            price: '',
            visibility: 1,
            files: {
                thumbnail_files: []
            },
            langs: ['PT', 'BR', 'EN', 'FR', 'DE', 'ES'],
            updateMode: false
        }
    },
    methods: {
        submitMenu() {
             if(this.created == true) {
                this.$vs.notify({
                    time: 4000,
                    text: this.$t('Este_directório_já_foi_registado'),
                    color:'danger',
                    position:'bottom-right',
                    iconPack: 'feather',
                    icon:'icon-alert-triangle'
                });

                return false;
            }

            let that = this;

            if (this.validations()) {
                this.$vs.loading();

                    let formData = new FormData();
                    let token = localStorage.getItem('usertoken');

                    // Fill the form information to send backend
                    formData.append('type', this.type_selected);
                    formData.append('hotel_id', this.hotel_id);
                    formData.append('name', this.name);
                    formData.append('visibility', +this.visibility);
                    formData.append('description', this.description);                    
                    formData.append('inputs', JSON.stringify(this.inputs));
                    /*
                    * Make the request 
                    */
                    let createUrl = '/myvilagale/hotel/' + this.hotel_id + '/menu?token=' + localStorage.getItem('usertoken');

                    let updateUrl = '/myvilagale/hotel/menu/update/' + this.menu.id + '?token=' + localStorage.getItem('usertoken');

                    this.$api.post(that.updateMode ? updateUrl : createUrl,
                    formData,
                    {
                        headers: {
                            'Content-Type': 'multipart/form-data',
                            'Authorization': 'Bearer ' + localStorage.getItem('usertoken')
                        }

                    })
                    .then(function(res) {
                    that.$vs.loading.close();
                    that.$vs.notify({
                        time: 4000,
                        text: that.updateMode ? that.$t('Registo_alterado_com_sucesso') : that.$t('Registo_criado_com_sucesso'),
                        color:'success',
                        position:'bottom-right',
                        iconPack: 'feather',
                        icon:'icon-check'
                    });

                    that.$emit('edit-finished');
                    that.$emit('hideType');
                })
                .catch(function() {
                    that.$vs.loading.close();
                    that.$vs.notify({
                        time: 4000,
                        text: that.updateMode ? that.$t('Ocorreu_um_erro_ao_alterar_o_registo') : that.$t('Ocorreu_um_erro_ao_criar_o_registo'),
                        color:'danger',
                        position:'bottom-right',
                        iconPack: 'feather',
                        icon:'icon-alert-triangle'
                    });
                    that.$emit('edit-finished');
                    that.$emit('hideType');
                });
            } else {
                this.$vs.loading.close();
            }
        },
        reset_inputs: function() {
            this.inputs = {
                'PT': {
                    name: '',
                    description: '',
                    information: '',
                    visibility: 1,
                },
                'BR': {
                    name: '',
                    description: '',
                    information: '',
                    visibility: 1,
                },
                'EN': {
                    name: '',
                    description: '',
                    information: '',
                    visibility: 1,
                },
                'FR': {
                    name: '',
                    description: '',
                    information: '',
                    visibility: 1,
                },
                'DE': {
                    name: '',
                    description: '',
                    information: '',
                    visibility: 1,
                },
                'ES': {
                    name: '',
                    description: '',
                    information: '',
                    visibility: 1,
                }
            }
        },

        validations() {
            let mandatory_langs = {
                'PT': 'portugal',
                'BR': 'brasil'
            };
            var hotels = JSON.parse(localStorage.getItem('hotels'));
            var hotel_selected = hotels.find((h, k) => h.id == this.hotel_id);

            var errors = [];

            for(var lang in this.inputs) {
                if(typeof mandatory_langs[lang] !== 'undefined') {
                    if(hotel_selected.country.toLowerCase() === mandatory_langs[lang] && this.inputs[lang].name == '') {
                        errors.push(this.$t('O_campo_Nome_é_obrigatório_no_idioma')+' ' + lang + '.');
                    }
                }
            }
            
            if(errors.length > 0) {
                for(let i = 0; i < errors.length; i++) {
                    this.$vs.notify({
                        time: 4000,
                        text: errors[i],
                        color:'danger',
                        position:'bottom-right',
                        iconPack: 'feather',
                        icon:'icon-alert-triangle'
                    });
                }
                return false;
            }
            return true;
        },
    },
    mounted() {
        this.reset_inputs();
        if (this.menu != '') {
            this.updateMode = true;
            this.menu.idiomas.forEach(idioma => {
                this.langs.forEach(lang => {
                    if(idioma.language == lang) {
                        idioma.visibility = parseInt(idioma.visibility) == 1 ? true : false;
                        this.inputs[lang] = idioma;
                    }
                });
            });

            this.type = this.menu.type;
            this.type_selected = this.menu.type;
            this.hotel_id = this.menu.hotel_id;
            this.visibility = Number(this.menu.visibility);
        }
    },

    components: {
        draggable
    }
}
</script>

<style scoped>
    .name_block {
        display: flex;
    }

    .input_name {
        width: 75%;
        margin-top: 25px;
    }

    .input_description {
        width: 75%;
    }

    .input_chapter{
        width: 60%;
    }

    .description_block {
        display: flex;
    }

    .chapters_block {
        display: flex;
    }

    .dropdown_label_description {
        margin-top: 25px;
    }

    .input_information {
        width: 75%;
    }

    .information_block {
        display: flex;
    }
</style>